module.exports = __webpack_public_path__ + "img/sc2.3d3392a2.png";